<div class="series-container">
  <div class="series-chips-grid" appearance="fill" id="series-chips" >
    <mat-label>Book Series:</mat-label>
    <mat-chip-set #seriesChips aria-label="Book Series">
      @for (s of series(); track s; let idx = $index) {
      <mat-chip [removable]="removable" (removed)="removeSeriesEvt(idx)" color="primary">
        {{ s.name }} -- Book {{ s.readingOrder }}
        @if (removable) {
        <mat-icon matChipRemove class="cancel-button" matSuffix>cancel</mat-icon>
        }
      </mat-chip>
      }
    </mat-chip-set>
  </div>
  <div class="flex-row">
 <!--   A d d   N e w   S e r i e s   F o r m   -->
 <kbm-series-input [series]="series()" (seriesUpdated)="onNewSeries($event)"></kbm-series-input>
  </div>
</div>